module.exports = __webpack_public_path__ + "img/15.fc606b4.png";